<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Students' Documents</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button class="btn add-btn" @click="showAddDocumentPopup()">
            <i class="fa fa-plus"></i>Add Document
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Search Filter -->
    <div class="row">
      <div class="form-group col-md-4">
        <label><b>Student Name</b></label>
        <input
          type="text"
          placeholder="Search Name Here"
          class="form-control"
          v-model="name"
        />
      </div>
      <div class="form-group col-md-2">
        <button
          class="btn btn-primary filter-btn"
          @click="getInstructorStudentsDocuments"
        >
          View
        </button>
      </div>
    </div>
    <!-- /Search Filter -->

    <!-- Pagination -->
    <div class="row mt-3">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
      <div class="col-md-6 text-md-right mt-2 mt-md-0">
        Sort by
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SortBy"
          style="width: 7.5em"
        >
          <option value="id">Student ID</option>
          <option value="name">Name</option>
          <option value="email">Email</option>
        </select>
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SortDirection"
          style="width: 8em"
        >
          <option value="asc">Ascending</option>
          <option value="desc">Descending</option>
        </select>
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Result -->
    <div class="card my-3" v-for="item in students" :key="item.UserId">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col-sm-4">
            <label class="mb-0"><b>Student ID:</b></label>
            {{ item.UserName }}
          </div>
          <div class="col-sm-4">
            <label class="mb-0"><b>Name:</b></label>
            {{ item.Name }}
          </div>
          <div class="col-sm-4">
            <label class="mb-0"><b>Email:</b></label>
            {{ item.Email }}
          </div>
        </div>
      </div>
      <div class="card-body py-0">
        <div class="row">
          <div class="col-12">
            <document-table
              :uploaderUserType="userTypeInstructor"
              type="Student Document"
              :userId="item.UserId"
              :key="counter"
            ></document-table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="students && !students.length" class="card mt-2">
      <div class="card-body text-center">{{ noRecordText }}</div>
    </div>
    <!-- /Result -->

    <!--Pagination -->
    <div
      style="margin-top: -8px"
      class="row mb-4"
      v-if="students && students.length"
    >
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          students.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->

    <!-- Add Document Modal -->
    <div class="modal custom-modal fade" id="addDocument" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header pt-4">
            <h5 class="modal-title">Add Document</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pt-3">
            <form @submit.prevent="addDocument">
              <!-- Name -->
              <div class="form-group">
                <label>Name<span class="text-danger">*</span></label>
                <select v-model="userId" class="form-control" required>
                  <option value>-- Select User --</option>
                  <option v-for="item in users" :value="item.Id" :key="item.Id">
                    {{ item.Name }}
                  </option>
                </select>
              </div>
              <!-- /Name -->

              <!-- Document -->
              <div class="form-group">
                <label style="line-height: 15px">
                  Document<span class="text-danger">*</span>
                  <span class="note">
                    (Maximum file size: 5 MB. Only zip, pdf, jpg, jpeg, png,
                    doc, docx, xls, xlsx are allowed)
                  </span>
                </label>
                <div class="row align-items-center">
                  <div :class="docFile ? 'col-11 pr-0' : 'col-12'">
                    <div class="custom-file">
                      <input
                        type="file"
                        class="custom-file-input"
                        accept=".zip,.pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
                        id="docFileUpload"
                        ref="docFileUpload"
                        @change="onDocSelected($event)"
                        required
                      />
                      <label class="custom-file-label" for="docFileUpload">
                        {{ docFileName }}
                      </label>
                    </div>
                  </div>
                  <div class="col-1" v-if="docFile">
                    <a
                      href="javascript:void(0)"
                      id="removeDocFile"
                      title="Remove Document"
                      @click.prevent="removeDocFile"
                    >
                      <i class="fa fa-trash" style="color: grey"></i>
                    </a>
                  </div>
                </div>
              </div>
              <!-- /Document -->

              <!-- Remarks -->
              <div class="form-group">
                <label>Remarks<span class="text-danger">*</span></label>
                <textarea
                  class="form-control"
                  v-model="remarks"
                  required
                ></textarea>
              </div>
              <!-- /Remarks -->

              <!-- Button -->
              <div class="submit-section mt-4">
                <button class="btn btn-primary submit-btn">Upload</button>
              </div>
              <!-- /Button -->
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- /Add Document Modal -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config";
import DocumentTable from "../../Shared/DocumentTable.vue";
import $ from "jquery";
export default {
  components: {
    DocumentTable,
  },
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      userTypeStudent: config.USERTYPE_STUDENT,
      name: "",
      students: [],
      counter: 0,
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "name",
        SortDirection: "asc",
      },
      totalRecords: "",
      //for add document popup
      userId: "",
      users: [],
      docFileName: "Upload Document",
      docFile: null,
      remarks: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
  },
  watch: {
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getInstructorStudentsDocuments();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
    "paging.SortBy": function () {
      this.paging.CurrentPage = 1;
      this.getInstructorStudentsDocuments();
    },
    "paging.SortDirection": function () {
      this.paging.CurrentPage = 1;
      this.getInstructorStudentsDocuments();
    },
  },
  methods: {
    getInstructorStudentsDocuments() {
      let param = {
        Token: this.tokenObj.Token,
        Name: this.name,
        CurrentPage: this.paging.CurrentPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        SortDirection: this.paging.SortDirection,
      };
      this.$store.state.isLoading = true;
      API.instructor
        .getInstructorStudentsDocuments(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.students = response.data.data;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            this.counter++;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getInstructorStudentsDocuments();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getInstructorStudentsDocuments();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getInstructorStudentsDocuments();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getInstructorStudentsDocuments();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getInstructorStudentsDocuments();
    },
    //add document popup
    showAddDocumentPopup() {
      $("#addDocument").modal("show");
    },
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    onDocSelected(event) {
      const file = event.target.files[0];
      if (!file) return;
      if (file.size > 5 * 1024 * 1024) {
        this.$swal("File size exceeds 5 MB", { icon: "error" });
        return;
      }
      this.docFileName = file.name;
      let self = this;
      let promise = self.getBase64(file);
      promise.then(function (result) {
        self.docFile = result;
      });
    },
    removeDocFile() {
      this.docFile = null;
      this.docFileName = "Upload Document";
      this.$refs.docFileUpload.value = null;
    },
    getInstructorStudentsForDropdown() {
      let param = {
        Token: this.tokenObj.Token,
      };
      API.instructor
        .getInstructorStudentsForDropdown(param)
        .then((response) => {
          if (response.data.success) {
            this.users = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    addDocument() {
      let param = {
        Token: this.tokenObj.Token,
        UserType: this.tokenObj.UserType,
        UserId: this.userId,
        File: this.docFile,
        FileName: this.docFileName,
        Remarks: this.remarks,
        InstructorId: this.tokenObj.Id,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to upload the document?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willAdd) => {
        if (willAdd) {
          this.$store.state.isLoading = true;
          API.document
            .addDocument(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                $("#addDocument").modal("hide");
                this.getInstructorStudentsDocuments();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
  },
  created() {
    this.getInstructorStudentsDocuments();
    this.getInstructorStudentsForDropdown();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SchoolUser/Instructor/StudentDocuments.vue